var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import '@/styles/InitiativeTracker/LongRestButton.less';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useApiInstance } from '@/api/index';
import { Icon } from '@/assets/icons/LibrarySvg';
import Loader from '@/components/UI/Loader';
/**
 * Floating control: applies long rest via API and passes updated character payloads to the parent.
 */
const LongRestButton = ({ pageButtonsContainer, show, onUpdated, }) => {
    const { t } = useTranslation();
    const api = useApiInstance();
    const [isLoading, setIsLoading] = useState(false);
    const handleClick = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const { characterApiInstance } = api;
            const { updatedCharacters } = yield characterApiInstance.longRest();
            onUpdated(updatedCharacters);
        }
        finally {
            setIsLoading(false);
        }
    });
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (!isLoading) {
                void handleClick();
            }
        }
    };
    if (!show || !pageButtonsContainer) {
        return null;
    }
    const title = t('initiativeTracker.longRestTitle');
    return createPortal(_jsx("button", { type: "button", className: "long-rest-toggle-button", style: { order: 35 }, title: title, "aria-label": title, tabIndex: 0, disabled: isLoading, onClick: () => void handleClick(), onKeyDown: handleKeyDown, children: isLoading ? _jsx(Loader, {}) : _jsx(Icon, { name: "bonfire_1" }) }), pageButtonsContainer);
};
export default LongRestButton;
